import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';

/**
 * A styled empty state component with icon, message and optional action
 * 
 * @param {Object} props - Component props
 * @param {Node} props.icon - The icon to display
 * @param {String} props.title - The main title/message
 * @param {String} props.description - Optional secondary description
 * @param {String} props.actionLabel - Optional label for the action button
 * @param {Function} props.onAction - Optional callback for the action button
 * @param {Boolean} props.fullHeight - Whether to use full height of parent
 * @param {Object} props.sx - Additional styling
 */
const EmptyState = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  fullHeight = false,
  sx = {}
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 5,
        borderRadius: 3,
        border: '1px dashed rgba(0, 0, 0, 0.12)',
        backgroundColor: 'rgba(0, 0, 0, 0.01)',
        height: fullHeight ? '100%' : 'auto',
        minHeight: fullHeight ? 300 : 'auto',
        ...sx
      }}
    >
      {icon && (
        <Box sx={{ mb: 2, color: 'text.disabled', fontSize: 60 }}>
          {icon}
        </Box>
      )}
      
      <Typography
        variant="h6"
        color="text.secondary"
        sx={{
          mb: description ? 1 : actionLabel ? 3 : 0,
          textAlign: 'center'
        }}
      >
        {title}
      </Typography>
      
      {description && (
        <Typography
          variant="body2"
          color="text.disabled"
          sx={{ mb: actionLabel ? 3 : 0, textAlign: 'center', maxWidth: 400 }}
        >
          {description}
        </Typography>
      )}
      
      {actionLabel && onAction && (
        <Button variant="contained" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Paper>
  );
};

export default EmptyState;